/**
 * @module features/client-device-management
 * @description Public barrel file for the Super Admin Client Device Management feature.
 * Exports route-level pages and domain contracts without leaking internal subcomponents.
 */
export { ClientDeviceClientsPage } from "./pages/ClientDeviceClientsPage";
export { OrgDeviceManagementPage } from "./pages/OrgDeviceManagementPage";
export * from "./types";

